module.exports = __webpack_public_path__ + "media/images/flags/gn-bf5b087387ce93eddfacb5f5ff5c656d.svg";